import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importHolidayCalendar: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.import.import-holiday-calendar',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Import ICS',
		description: 'label for import holiday calendar button',
	},
});
